export class BookingListGetSearchProperties {
  bookingID: number;
  pnr: string;
  supplier: string;
  bookingPccCode: string;
  tkt: string;
  name: string;
  trip: string;
  travelDate: string;
  bookingDate: string;
  bookingStatus: string;
  agencyId: string;
  requestTypeName: string;
  offlinebookingId: string;
  offlineagencyId: string;
  amount: number;
  baseFare: number;
  totalTaxes: number;
  loginName: string;
  ticketIssuanceSource: string = "";
}
export class BookingListProperties {
  bookingID: number;
  pnr: string;
  title: string;
  supplier: string;
  bookingPccCode: string;
  tkt: string;
  name: string;
  trip: string;
  travelDate: string;
  bookingDate: string;       
  bookingStatus: string;
  agencyId: string;
  requestTypeName: string;
  offlinebookingId: string;
  offlineagencyId: string;
  amount: number;

  baseFare: number;
  totalTaxes: number;
  loginName: string;

  groupTicketId:number=0;
  ticketIssuanceSource: string = "";
}
export class BookingRights {
  roleId: number = 0;
  //:  boolean = false;
  book: boolean = false;
  searchBookings: boolean = false;
  newBookings: boolean = false;
  myBookings: boolean = false;
  updateBookings: boolean = false;
  viewBookings: boolean = false;
}

export class BookingSearchListProperties {
  bookingID: number = 0;
  pnr: string = "";
  supplier: string = "";
  tkt: string = "";
  name: string = "";
  loginUserId: number;
  trip: string = "";
  fromBookingDate: string = "";
  toBookingDate: string = "";
  bookingDate: string = "";
  travelDate: string = "";
  bookingStatus: number = 0;
  agencyId: string = "";
  byAgency: string = "";
  userId: number = 0;
  rowCount: number = 0;
  byagencyUser: string = "";
  issuanceStaff: string = "";
}
export class BookingStatus {
  id: number = 0;
  bookingStatus: string = "";

}
export class loginUserList {
  userIdByBranches: number = 0;
  loginName: string = "";

}
export class BookingTripDetailsSearch {
  fromAirport: string = "";
  toAirport: string = "";
  journeyType: string = "";
  jrTypeMulti: string;
}
export class managerlistbyuserid {
  userid: number = 0;
  agencyid: string = "";

}
export class BookingListNew {
  agencyId: string;
  fromBooking: string;
  toBooking: string;
  userId=0;
}
